import { Dispatch, SetStateAction } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { LINKS, relPath } from '../../../../Routs/config';
import CreateKnisa from './Create/CreateKnisa';
import KnisotListView from './Components/KnisotListView';
import useKnisotList from './services/hooks/useKnisotList';

type Props = {
    date: string;
    setDate: Dispatch<SetStateAction<string>>;
    dateEnd: string;
    setDateEnd: Dispatch<SetStateAction<string>>;
    handleDate: (e: object | object[]) => void;
    selectedDate: Date | Date[];
    setDefaultDate: Date | Date[];
};

const KnisotMain = ({
    date,
    setDate,
    dateEnd,
    setDateEnd,
    handleDate,
    selectedDate,
    setDefaultDate,
}: Props) => {
    const location = useLocation();
    const list = useKnisotList({ date, dateEnd, locationPath: location.pathname });

    return (
        <Routes>
            <Route
                index
                element={
                    <KnisotListView
                        {...list}
                        setDate={setDate}
                        setDateEnd={setDateEnd}
                        handleDate={handleDate}
                        selectedDate={selectedDate}
                        setDefaultDate={setDefaultDate}
                    />
                }
            />
            <Route
                path={relPath(LINKS.knisot.teudot.editGeneral, LINKS.knisot.teudot.mainURL)}
                element={<CreateKnisa />}
            />
            <Route
                path={relPath(LINKS.knisot.teudot.create, LINKS.knisot.teudot.mainURL)}
                element={<CreateKnisa />}
            />
        </Routes>
    );
};

export default KnisotMain;
